import "./i18n";
import "./index.css";
import "../node_modules/primeflex/primeflex.css";
import axios from "axios";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { HashRouter, Route, Routes } from "react-router-dom";
import SignIn from "./component/SignIn/SignIn";
import ConfirmRegistration from "./component/ConfirmRegistration/ConfirmRegistration";
import TypeCompany from "./component/SignUp/TypeCompany";
import Layout from "./component/Layout/Layout";
import RegisterCorporation from "./component/Corporation/RegisterCorporation";
import PaginatorProvider from "./component/Context/PagesContext";
import ProducerProvider from "./component/Context/ProducersContext";
import RegisterProducers from "./component/Producers/RegisterProducers";
import AddProduct from "./component/Product/AddProduct";
import ProductProvider from "./component/Context/ProductContext";
import ProductsMap from "./component/ProductsPage/componentsProducts/ProductsMap/ProductsMap";
import RecoverPassword from "./component/RecoverPassword/RecoverPassword";
import RecoverCompany from "./component/RecoverCompany/RecoverCompany";
import RequestCompanyRecoveryLink from "./component/RecoverCompany/RequestCompanyRecoveryLink";
import ErrorBoundary from "./component/ErrorBoundary/ErrorBoundary";

// Without a default timeout, a hung backend/proxy leaves a request pending
// forever, so every "loading" flag gated on it (and its .catch handler,
// which would otherwise reset the flag) never fires.
axios.defaults.timeout = 20000;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ErrorBoundary>
    <HashRouter>
      <Routes>
        <Route path="/*" element={<Layout />} />
        <Route path="signin" element={<SignIn />} />
        <Route path="signup" element={<TypeCompany />} />
        <Route path="company" element={<ProductsMap />} />
        <Route
          path="signin/recoverPassword/:type"
          element={<RecoverPassword />}
        />
        <Route
          path="signup/confirmRegistration"
          element={<ConfirmRegistration />}
        />
        <Route path="recoverCompany/:token" element={<RecoverCompany />} />
        <Route
          path="recoverCompany"
          element={<RequestCompanyRecoveryLink />}
        />
        <Route
          path="producers"
          element={
            <PaginatorProvider>
              <ProducerProvider>
                <RegisterProducers />
              </ProducerProvider>
            </PaginatorProvider>
          }
        />
        <Route
          path="corporation"
          element={
            <PaginatorProvider>
              <ProducerProvider>
                <RegisterCorporation />
              </ProducerProvider>
            </PaginatorProvider>
          }
        />
        <Route
          path="addproduct"
          element={
            <PaginatorProvider>
              <ProductProvider>
                <AddProduct />
              </ProductProvider>
            </PaginatorProvider>
          }
        />
      </Routes>
    </HashRouter>
  </ErrorBoundary>
);

reportWebVitals();
